import React, { useEffect, useState } from "react";
import InnerTitle2 from "../../components/InnerTitle2";
import { cmsPage } from "../../services/cms.service";
import { renderCmsContent } from "../../../../utils/commonfunction";

function PrivacyPolicy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  // change only the slug here
  const SLUG = "privacy-policy";

  useEffect(() => {
    fetchCMSPage();
  }, []);

  const fetchCMSPage = async () => {
    try {
      const res = await cmsPage({slug:SLUG});

      if (res?.success) {
        setData(res.data);
      }

      setLoading(false);
    } catch (error) {
      console.log("CMS Fetch Error:", error);
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="py-20 text-center text-gray-400 body-lg">Loading...</div>;
  }

  return (
    <>
      <div className="contact-bg">
        <InnerTitle2 title={data?.title || "Privacy Policy"} />

        <div className="privacy-policy-bg py-10">
          <div className="container">
            <div className="body-lg text-black !leading-relaxed" dangerouslySetInnerHTML={{ __html: renderCmsContent(data?.description) }}></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
